/**
 * Filters an array, extracting only non-empty string entries.
 * Non-string values are filtered out, and string values are trimmed before checking.
 * Returns undefined if the resulting array is empty or the input is not an array.
 */
export function normalizeStringArray(values: unknown): string[] | undefined {
  if (!Array.isArray(values) || values.length === 0) {
    return undefined;
  }
  const normalized = values
    .filter(
      (entry): entry is string =>
        typeof entry === "string" && entry.trim().length > 0,
    )
    .map((entry) => entry.trim());
  return normalized.length > 0 ? normalized : undefined;
}
